import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Link } from '../shared/models/link';

@Injectable({
  providedIn: 'root'
})
export class OdrService implements OnInit {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor( private http: HttpClient) { }
  
  ngOnInit() {
 }

  /** GET odrlink. Will 404 if not found */
  getOdrLink(): Observable<Link> {
    return this.http.get<Link>('odrlink').pipe(
      catchError(this.handleError<Link>(`get odr.external.link`))
    );
  }

  /** GET odrlink. Will 404 if not found */
  getPeopleList(): Observable<string> {
    return this.http.get<string>('peopleList').pipe(
      catchError(this.handleError<string>(`get odr.external.link`))
    );
  }

  /**
   * Calls server to query LDAP to look up a user by there common name from the partial text.
   *
   * @param query - partial text of users common name
   */
   lookupContact(query: string): Observable<any[]> {
    return this.http.get<any[]>('ldap?query=' + query).pipe(
      catchError(this.handleError<any[]>(`Look up person`))
    );
  }

  /**
   * Calls server to query LDAP to look up a user by there common name from the partial text.
   *
   * @param query - partial text of users common name
   */
   lookupPerson(query: string, testStr: string): Observable<any[]> {
    let headers = new HttpHeaders().set('header-name', 'header-value');
    headers = headers.set('authentication', testStr);
    
    return this.http.get<any[]>('person?query=' + query, { headers: headers }).pipe(
      catchError(this.handleError<any[]>(`Look up person`))
    );
  }

  /**
   * Calls server to query LDAP to look up a user by there common name from the partial text.
   *
   * @param query - partial text of users common name
   */
   lookupContactDetails(query: string, testStr: string): Observable<any[]> {
    let headers = new HttpHeaders().set('header-name', 'header-value');
    headers = headers.set('authentication', testStr);
    return this.http.get<any[]>('person-details?motraId=' + query, { headers: headers }).pipe(
      catchError(this.handleError<any[]>(`Look up person`))
    );
    
  }

  /**
   * Calls server to destroy user's token and session.
   */
   logout(): Observable<void> {
    return this.http.get<void>('logout');
  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}